import { SEOObjects } from './models/SEO';

const SEO: SEOObjects = {
  '/': {
    keyword:
      'paraphrasing tool, smart thesaurus, article rewriter, thesaurus, smart, sentences, rewrite, smart thesaurus for sentences, Reword Essays, rewrite essays, plagiarism, paraphrasing, paraphraser, short response changer, essay changer, smart thesaurus, thesaurus, thesaurus for sentences, paper changer, reworder, artificial intelligence, natural language processing, NLP, reword responses, rephrase, paraphrasing, reword, rewordify, article spinner, reword paraphraph, paraphrasing tool online free, rewrite sentences, rewrite sentences generator, rephrase sentences, reword this, free paraphrasing',
    title: 'Paraphrasing Tool | QuillBot AI',
    description:
      "QuillBot's paraphrasing tool is trusted by millions worldwide to rewrite sentences, paragraphs, or articles using state-of-the-art AI.",
    og_url: 'https://quillbot.com',
    og_title: 'AI Paraphrasing Tool | QuillBot',
    og_description:
      'Millions of students and professionals use our full-sentence thesaurus to rewrite content, get creative suggestions and removes writer’s block. QuillBot uses state-of-the-art AI to rewrite any sentence or article you give it.',
    canonical: 'https://quillbot.com',
    flash_page_title: 'Free Paraphrasing Tool - Best Article Rewriter | QuillBot',
    flash_page_description: '',
    // 'QuillBot is a state-of-the-art paraphrasing tool. It is the best article rewriter available, and can completely paraphrase an entire article for free. Simply input a sentence, and hit the "Paraphrase" button. QuillBot will then rephrase the content while maintaining the original meaning. You can then click on any of the words or phrases to have a drop down thesaurus appear which can then provide further edits in order to optimize your sentence. It is the best article spinner out there. We will even provide statistics to how fluent the sentences are, and how much they have changed. QuillBot can also function as a grammar checker and fluency enhancer. In addition to this, it can provide you with creative suggestions on your sentences. We labeled the software as a "smart thesaurus for sentences" or a full-sentence thesaurus. QuillBot underlying technology uses complete machine learning. This means that when you interact with the website, you are providing data that will be used to improve QuillBot\'s proficiency. This also means that the version you are using will be the worst version of the model, and that it will constantly improve. Users have been uitilizing QuillBot for a variety of purposes. They use QuillBot as an SEO optimizer tool, in order to improve their writing, or simply get over writers block. The language that QuillBot produces is natural, and will improve overtime as well. Our mission is to achieve human-level paraphrasing. Once we achieve this task, we will aim to produce language in particular linguistic styles or degrees of sophistication. We will even allow users to control the degree of permutation that the paraphrasing tool produces. This will give users complete control over QuillBot and the ability to manipulate language to meet their needs. While our goals our ambitious, we see a clear path forward towards achieving them!',
  },
  '/summarize': {
    keyword:
      'summarize, summarizer, summary, create summary, summarization tool, summarizing tool, best summarizer, free summarizer, ai summarizer, summarize article, summarize online, abstractive summarization, extractive summarization, summary generator, summary maker, summary paragraph, article summarizer, summary maker',
    title: 'Text Summarizer | QuillBot AI',
    description:
      "QuillBot's summarizer is trusted by millions worldwide to condense long articles, papers, or documents and into key summary paragraphs using state-of-the-art AI.",
    og_url: 'https://quillbot.com/summarize',
    og_title: 'AI Summarizer Tool | QuillBot',
    og_description:
      'Summarize any article, essay, or document with a few clicks and get a key summary in seconds. Trusted by Millions Worldwide. Super easy to use.',
    canonical: 'https://quillbot.com/summarize',
    flash_page_title: 'Free Paraphrasing Tool - Best Article Rewriter | QuillBot',

    flash_page_description:
      'QuillBot Summarize is an online summarization tool that allows you to take an article, paper, or document and condense it into the most important information at a click of a button. Our AI uses natural language processing to grab critical information while maintaining the original context. There are two automatic summarization types: Key Sentences and Paragraph. The Key Sentences mode takes the input and shows the most important sentences within it. You can use the summary length slider to change how many sentences you receive. Paragraph mode takes the input and condenses it into a paragraph that combines elements of summarizing and paraphrasing, creating a naturally flowing text that explains key points. Users are also able to control how long they want the paragraph to be using the summary length slider. The summarizing tool can be used with a multitude of sources. Whether you have a news article, a research paper, or even a confusing paragraph, the summarizer tool will help you get the information that you need. If you want to know about an update on the stock market, or the third season of your favorite show, QuillBot has you covered.',
  },
  '/co-writer': {
    keyword:
      'co-writer, researcher, research helper, writer, automatic writer, sentence completer, AI sentence completer, AI writer, ghost writer, text writer, article helper, article writer,',
    title: 'Co-Writer | Quillbot AI',
    description:
      'QuillBot’s Co-Writer is an all-in-one writing space that combines online research capabilities, note taking, AI-assisted composition and a lot more to help you supercharge your writing workflow.',
    og_url: 'https://quillbot.com/co-writer',
    og_title: 'Co-Writer | Quillbot AI',
    og_description:
      'QuillBot’s Co-Writer is an all-in-one writing space that combines online research capabilities, note taking, AI-assisted composition and a lot more to help you supercharge your writing workflow.',
    canonical: 'https://quillbot.com/co-writer',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/co-writer/home': {
    keyword:
      'co-writer, researcher, research helper, writer, automatic writer, sentence completer, AI sentence completer, AI writer, ghost writer, text writer, article helper, article writer,',
    title: 'Co-Writer | Quillbot AI',
    description:
      'QuillBot’s Co-Writer is an all-in-one writing space that combines online research capabilities, note taking, AI-assisted composition and a lot more to help you supercharge your writing workflow.',
    og_url: 'https://quillbot.com/co-writer',
    og_title: 'Co-Writer | Quillbot AI',
    og_description:
      'QuillBot’s Co-Writer is an all-in-one writing space that combines online research capabilities, note taking, AI-assisted composition and a lot more to help you supercharge your writing workflow.',
    canonical: 'https://quillbot.com/co-writer',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/grammar-check': {
    keyword:
      'free grammar check, grammar check, check grammar, grammar checker, AI grammar check, spelling check, spell check',
    title: 'Free Grammar Checker | QuillBot AI',
    description:
      'QuillBot’s free online grammar checker reviews your English text for grammar, spelling, and punctuation errors using cutting-edge AI technology.',
    og_url: 'https://quillbot.com/grammar-check',
    og_title: 'Free Grammar Checker | QuillBot AI',
    og_description:
      'QuillBot’s free online grammar checker to review your English text for grammar, spelling, and punctuation errors using cutting-edge AI technology.',
    canonical: 'https://quillbot.com/grammar-check',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/citation-generator': {
    keyword:
      'free citation generator, citation generator, citation generator machine, mla generator, chicago generator, apa generator',
    title: 'Free Citation Generator: APA, MLA, and Chicago Style | QuillBot',
    description:
      'Generate in-text citations and full reference lists in the APA, MLA, & Chicago citation styles with QuillBot’s free Citation Generator.',
    og_url: 'https://quillbot.com/citation-generator',
    og_title: 'Free Citation Generator: APA, MLA, and Chicago Style | QuillBot',
    og_description:
      'Generate in-text citations and full reference lists in the APA, MLA, & Chicago citation styles with QuillBot’s free Citation Generator.',
    canonical: 'https://quillbot.com/citation-generator',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/plagiarism-checker': {
    keyword: 'plagiarism checker',
    title: 'Plagiarism Checker | QuillBot AI',
    description:
      "Use QuillBot's Plagiarism Checker to ensure your sources are properly credited, whether they're from online content, news, academic articles, or other materials.",
    og_url: 'https://quillbot.com/plagiarism-checker',
    og_title: 'Plagiarism Checker | QuillBot AI',
    og_description:
      "Use QuillBot's Plagiarism Checker to ensure your sources are properly credited, whether they're from online content, news, academic articles, or other materials.",
    canonical: 'https://quillbot.com/plagiarism-checker',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/premium': {
    keyword: 'quillbot premium, buy premium, quillbot pricing',
    title: 'QuillBot Premium: Making Writing Painless | QuillBot',
    description:
      'Get started today and instantly rewrite any sentence or paragraph by using the best paraphrasing tool online.',
    og_url: 'https://quillbot.com/premium',
    og_title: 'QuillBot Premium: Making Writing Painless | QuillBot',
    og_description:
      'Get started today and instantly rewrite any sentence or paragraph by using the best paraphrasing tool online.',
    canonical: 'https://quillbot.com/premium',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/upgrade': {
    keyword: 'quillbot plans, buy premium, quillbot pricing',
    title: 'QuillBot | Pricing & Plans - Upgrade to Premium',
    description:
      'Looking for information on QuillBot Premium? Checkout our monthly, semi-annual, and annual Premium plans to see how QuillBot Premium can make writing painless for you.',
    og_url: 'https://quillbot.com/upgrade',
    og_title: 'QuillBot | Pricing & Plans - Upgrade to Premium',
    og_description:
      'Looking for information on QuillBot Premium? Checkout our monthly, semi-annual, and annual Premium plans to see how QuillBot Premium can make writing painless for you.',
    canonical: 'https://quillbot.com/upgrade',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/contact': {
    keyword: 'contact us, quillbot contact',
    title: 'Contact Us | QuillBot',
    description:
      "Have a question? We'd love to hear from you - write us a message and we'll get back to you as soon as we can!",
    og_url: 'https://quillbot.com/contact',
    og_title: 'Contact Us | QuillBot',
    og_description:
      "Have a question? We'd love to hear from you - write us a message and we'll get back to you as soon as we can!",
    canonical: 'https://quillbot.com/contact',
    flash_page_title: 'Support Center: Contact Us',
    flash_page_description:
      "Have a question? We'd love to hear from you - write us a message and we'll get back to you as soon as we can!",
  },
  '/careers': {
    keyword: 'quillbot careers, open positions quillbot',
    title: 'Careers | QuillBot',
    description:
      'Want to join QuillBot in our mission to make writing painless? You can view and apply to job opportunities at QuillBot here!',
    og_url: 'https://quillbot.com/careers',
    og_title: 'Careers | QuillBot',
    og_description:
      'Want to join QuillBot in our mission to make writing painless? You can view and apply to job opportunities at QuillBot here!',
    canonical: 'https://quillbot.com/careers',
    flash_page_title: 'Open Positions',
    flash_page_description:
      'QuillBot is looking for world-class talent to change the way people write. Learn more about our open positions here.',
  },
  '/affiliates': {
    keyword: 'quillbot affiliates',
    title: 'Affiliate Program | QuillBot',
    description:
      'Become an affiliate and start earning big! Earn 10% - 20% commission per referral when you become a QuillBot Affiliate. Join the QuillBot Affiliate program today!',
    og_url: 'https://quillbot.com/affiliates',
    og_title: 'Affiliate Program | QuillBot',
    og_description:
      'Become an affiliate and start earning big! Earn 10% - 20% commission per referral when you become a QuillBot Affiliate. Join the QuillBot Affiliate program today!',
    canonical: 'https://quillbot.com/affiliates',
    flash_page_title: 'Earn Big Through Affiliate Sales',
    flash_page_description: '',
  },
  '/terms': {
    keyword: '',
    title: 'Terms Of Service | QuillBot',
    description:
      'We invite you to access our websites and use the QuillBot service, but please note that your invitation is subject to your agreement with these Terms of Service.',
    og_url: 'https://quillbot.com/terms',
    og_title: 'Terms Of Service | QuillBot',
    og_description:
      'We invite you to access our websites and use the QuillBot service, but please note that your invitation is subject to your agreement with these Terms of Service.',
    canonical: 'https://quillbot.com/terms',
    flash_page_title: 'QuillBot Terms Of Service',
    flash_page_description: '',
  },
  '/privacy': {
    keyword: '',
    title: 'Privacy Policy | QuillBot',
    description:
      'Read this policy to understand how we collect, use, and share your personal information.',
    og_url: 'https://quillbot.com/privacy',
    og_title: 'Privacy Policy | QuillBot',
    og_description:
      'Read this policy to understand how we collect, use, and share your personal information.',
    canonical: 'https://quillbot.com/privacy',
    flash_page_title: 'QuillBot Privacy Policy',
    flash_page_description: '',
  },
  '/ccpa': {
    keyword: '',
    title: 'California Resident Privacy Notice | QuillBot',
    description:
      'If you are a California resident, this page provides more information about your California privacy rights and explains how you can exercise those rights.',
    og_url: 'https://quillbot.com/ccpa',
    og_title: 'California Resident Privacy Notice | QuillBot',
    og_description:
      'If you are a California resident, this page provides more information about your California privacy rights and explains how you can exercise those rights.',
    canonical: 'https://quillbot.com/ccpa',
    flash_page_title: 'QuillBot California Resident Privacy Notice',
    flash_page_description: '',
  },
  '/word': {
    keyword: '',
    title: 'QuillBot for Microsoft Word | QuillBot',
    description:
      'Download QuillBot for Microsoft Word and increase your writing efficiency and quality today!',
    og_url: 'https://quillbot.com/word',
    og_title: 'QuillBot for Microsoft Word | QuillBot',
    og_description:
      'Download QuillBot for Microsoft Word and increase your writing efficiency and quality today!',
    canonical: 'https://quillbot.com/word',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/api-access': {
    keyword: 'QuillBot API, QuillBot API purchase',
    title: 'QuillBot API for Developers | QuillBot',
    description: 'Learn more about our API, its capabilities, and its pricing. Get started today!',
    og_url: 'https://quillbot.com/api-access',
    og_title: 'QuillBot API for Developers | QuillBot',
    og_description:
      'Learn more about our API, its capabilities, and its pricing. Get started today!',
    canonical: 'https://quillbot.com/api-access',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/about': {
    keyword: 'QuillBot team',
    title: 'About Us | QuillBot',
    description:
      'QuillBot is on a mission to help millions of people write painlessly. Read about our journey here!',
    og_url: 'https://quillbot.com/about',
    og_title: 'About Us | QuillBot',
    og_description:
      'QuillBot is on a mission to help millions of people write painlessly. Read about our journey here!',
    canonical: 'https://quillbot.com/about',
    flash_page_title: 'QuillBot Team',
    flash_page_description: '',
  },
  '/hotkeys': {
    keyword: '',
    title: 'Hotkeys and Keyboard Shortcuts | QuillBot',
    description: 'Learn some tips, tricks, and shortcuts for our Paraphrasing tool.',
    og_url: 'https://quillbot.com/hotkeys',
    og_title: 'Hotkeys and Keyboard Shortcuts | QuillBot',
    og_description: 'Learn some tips, tricks, and shortcuts for our Paraphrasing tool.',
    canonical: 'https://quillbot.com/hotkeys',
    flash_page_title: 'Hotkeys and Keyboard Shortcuts',
    flash_page_description: 'Learn some tips, tricks, and shortcuts for our Paraphrasing tool.',
  },
  '/signup': {
    keyword: '',
    title: 'Sign Up – Create an Account | QuillBot ',
    description:
      'Create a free QuillBot account to save time and instantly improve your writing using cutting-edge AI.',
    og_url: 'https://quillbot.com/signup',
    og_title: 'Sign Up – Create an Account | QuillBot ',
    og_description:
      'Create a free QuillBot account to save time and instantly improve your writing using cutting-edge AI.',
    canonical: 'https://quillbot.com/signup',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/login': {
    keyword: '',
    title: 'Log In | QuillBot AI',
    description:
      'Log in to your QuillBot account and start writing smarter, faster, and more effectively.',
    og_url: 'https://quillbot.com/login',
    og_title: 'Log In | QuillBot AI',
    og_description:
      'Log in to your QuillBot account and start writing smarter, faster, and more effectively.',
    canonical: 'https://quillbot.com/login',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/workshop': {
    keyword: '',
    title: 'Get Your Thesis Back on Track Workshop | QuillBot',
    description:
      'QuillBot is partnering with universities around the world to offer free workshops and resources to help students get their writing and research back on track. Sign Up Today!',
    og_url: 'https://quillbot.com/workshop',
    og_title: 'Get Your Thesis Back on Track Workshop | QuillBot',
    og_description:
      'QuillBot is partnering with universities around the world to offer free workshops and resources to help students get their writing and research back on track. Sign Up Today!',
    canonical: 'https://quillbot.com/workshop',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/student-resources': {
    keyword:
      'academic writing, student resources, writing resources, academic resources, academic essay, writing tools online, academic essay writing, writing academic english, writing tools for students, academic resources for students, writing resources for students, academic research writing, academic writing and research, online writing resources',
    title: 'Student Resources for Academic Writing and Research | QuillBot AI',
    description:
      'Being a student is hard--but writing and research don’t have to be. Learn how QuillBot’s AI writing tools help you build and enhance your academic writing and research skills as you work.',
    og_url: 'https://quillbot.com/student-resources',
    og_title: 'Student Resources for Academic Writing and Research | QuillBot AI',
    og_description:
      'Being a student is hard--but writing and research don’t have to be. Learn how QuillBot’s AI writing tools help you build and enhance your academic writing and research skills as you work.',
    canonical: 'https://quillbot.com/student-resources',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/word-counter': {
    keyword: 'Word Count,Character Count, Paragraph Count,Sentence Count',
    title: 'Word Counter Tool - Count Words & Characters in Your Writing | QuillBot AI ',
    description:
      'Count words and characters in real-time using QuillBot’s Word Counter tool. It’s simple and free. Great for social media, assignments, SEO, and more.',
    og_url: 'https://quillbot.com/word-counter',
    og_title: 'Word Counter Tool - Count Words & Characters in Your Writing | QuillBot AI ',
    og_description:
      'Count words and characters in real-time using QuillBot’s Word Counter tool. It’s simple and free. Great for social media, assignments, SEO, and more.',
    canonical: 'https://quillbot.com/word-counter',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/guides/paraphrasing': {
    keyword:
      'what is paraphrasing, what does paraphrase mean, paraphrasing examples, when to paraphrase, how to paraphrase',
    title: 'QuillBot’s Guide to Paraphrasing | When & How To Paraphrase',
    description:
      'A complete guide to paraphrasing. This expert-written guide covers paraphrase definition, types, examples, importance, and more.',
    og_url: 'https://quillbot.com/guides/paraphrasing',
    og_title: 'QuillBot’s Guide to Paraphrasing | When & How To Paraphrase',
    og_description:
      'A complete guide to paraphrasing. This expert-written guide covers paraphrase definition, types, examples, importance, and more.',
    canonical: 'https://quillbot.com/guides/paraphrasing',
    flash_page_title: '',
    flash_page_description: '',
  },
  '/guides/ai-writing-assistant': {
    keyword: '',
    title: 'QuillBot AI is the Best AI Writing Assistant in 2022',
    description:
      "Write better than ever with QuillBot's AI writing assistant. Save time, energy, and brainpower by utilizing all AI has to offer",
    og_url: 'https://quillbot.com/guides/ai-writing-assistant',
    og_title: 'QuillBot AI is the Best AI Writing Assistant in 2022',
    og_description:
      "Write better than ever with QuillBot's AI writing assistant. Save time, energy, and brainpower by utilizing all AI has to offer",
    canonical: 'https://quillbot.com/guides/ai-writing-assistant',
    flash_page_title: '',
    flash_page_description: '',
  },
};

export default SEO;
